import { useQuery } from '@tanstack/react-query';
import { payersApi } from '../api/payersApi';
import { payerKeys } from '../queryKeys';

export function usePayerDirectory(query: string) {
  const search = useQuery({
    queryKey: payerKeys.directory(query),
    queryFn: () => payersApi.searchDirectory(query),
  });

  return { ...search, results: search.data ?? [] };
}
